<script>
import useTools from "@/use/Tools";
import axios from "axios";
import {onMounted, ref} from "vue";

export default {
    props: {
        disabled: Boolean,
    },
    setup(props, {emit}) {
        const {$route} = useTools();
        const dialog = ref(false);
        const loading = ref(false);

        const totalReady = ref(0);
        const totalNotReady = ref(0);
        const loadingTotal = ref(false);

        function countInQueue() {
            loadingTotal.value = true;
            axios.get('/cvTechSourcings/countInQueue', {
                params: {
                    sourcingId: $route.params.id,
                    state: 'EMAIL_QUEUE',
                    source: 'EMAIL'
                }
            }).then(response => {
                totalReady.value = response.data.totalReady;
                totalNotReady.value = response.data.totalNotReady;
            }).finally(() => {
                loadingTotal.value = false;
            });
        }

        function upload() {
            loading.value = true;
            axios.post(`/cvTechSourcings/uploadFromEmail/${$route.params.id}`).then(response => {
                emit('upload', response.data);
                countInQueue();
                dialog.value = false;
            }).finally(() => {
                loading.value = false;
            });
        }

        let intervalId;

        onMounted(() => {
            intervalId = setInterval(() => {
                countInQueue();
            }, 10000);
        });

        countInQueue(() => {
            clearInterval(intervalId);
        });

        return {
            dialog,
            loading,
            loadingTotal,
            totalReady,
            totalNotReady,
            upload,
        }
    },
}
</script>

<template>
    <div>

        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="500"
        >
            <v-card>
                <w-toolbar color="red" :title="$t('recruitment_request.sourcing_email_title')"/>
                <v-card-text>
                    <v-container fluid>
                        <h4>
                            <span class="blue--text">{{ totalReady }}</span> {{ $t('recruitment_request.sourcing_email_description') }}
                        </h4>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog = false"/>
                    <w-btn
                        color="red"
                        icon="mdi-database-import"
                        :text="$t('common.import')"
                        :loadin="loading"
                        @press="upload"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-badge
            color="blue"
            bordered
            overlap
            left
            :content="totalReady"
        >
            <v-btn
                depressed
                small
                :disabled="disabled"
                class="white--text"
                color="red"
                :loading="loadingTotal"
                @click="dialog = true"
            >
                {{ $t('common.email') }}
                <v-icon right>mdi-email-check</v-icon>
            </v-btn>
        </v-badge>
    </div>
</template>